<template>
  <div class="p-4">
    <p>Bitte wählen Sie die Märkte aus, in denen die Änderungen übernommen werden sollen</p>


    <div v-for="product in value.page.products" class="mt-4">
      <div class="mb-2">
        Art. Nr.:
        <span class="font-bold">{{ product.articleNumber }}</span>
        <br>
        <span v-if="showMoreInfos[product.productId]" class=" hover:text-trader-blue cursor-pointer hover:underline"
              @click="toggleShowMore(product.productId)">Weniger anzeigen...</span>
        <span v-else class=" hover:text-trader-blue cursor-pointer hover:underline"
              @click="toggleShowMore(product.productId)">Mehr anzeigen...</span>
      </div>


      <table v-if="showMoreInfos[product.productId]" class="mb-4 w-full">
        <tr v-for="field in product.productCustomFields" class="border-b">
          <td class="bg-trader-gray pl-1 w-1/4">{{ field.field }}:</td>
          <td class="pl-1">{{ field.value }}</td>
        </tr>
      </table>

      <div class="flex">
        <ul class="grid grid-cols-12 gap-1 text-center ">
          <li v-for="market in sortedMarkets(product.marketIds)" class="py-1 px-2 cursor-pointer"
              @click="toggleMarketSelection(product.productId, market)"
              :class="this?.productSelectedMarkets[product.productId]?.indexOf(market) >= 0 ? 'bg-trader-blue text-white' : 'bg-trader-gray'">
            {{ getMarketName(market) }}
          </li>
        </ul>
        <div class="flex ml-1  gap-1">
          <div class="bg-trader-gray py-1 px-2 cursor-pointer" @click="selectAllMarketsForProduct(product)">Alles Auswählen</div>
          <div class="bg-trader-gray py-1 px-2 cursor-pointer" @click="deselectAllMarketsForProduct(product)">Alles Abwählen</div>
        </div>
      </div>
    </div>

    <div class="flex flex-grow mt-8">
      <div class="flex-grow flex gap-1">
        <button class="bg-trader-gray py-1 px-2 cursor-pointer" @click="selectEverything">Alles auswählen</button>
        <button class="bg-trader-gray py-1 px-2 cursor-pointer" @click="deselectEverything">Alles abwählen</button>
      </div>

      <div class="flex gap-1">
        <button class="bg-trader-red text-trader-dark-red py-1 px-2 cursor-pointer" @click="close">Abbrechen</button>
        <button class="bg-trader-green text-trader-dark-green py-1 px-2 cursor-pointer" @click="save">Speichern</button>
      </div>


    </div>
  </div>
</template>

<script>
import {eventBus} from "@/application/EventBus";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    pageId: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      productSelectedMarkets: {},
      showMoreInfos: {},
    }
  },
  methods: {
    close() {
      eventBus.closeModal();
    },
    save() {
      let save = JSON.parse(JSON.stringify(this.value.page));

      for (const product of save.products) {
        if (this.productSelectedMarkets[product.productId]?.length > 0) {
          product.marketIds = this.productSelectedMarkets[product.productId];
        } else {
          product.marketIds = [];
        }
      }

      //remove all products without markets
      save.products = save.products.filter(product => product.marketIds.length > 0);

      this.value.onSave(save);

      //TODO: Warnmeldung, wenn nichts zum speichern ausgewählt wurde

      this.close();
    },
    selectEverything() {
      for (const product of this.value.page.products) {
        this.selectAllMarketsForProduct(product);
      }
    },
    deselectEverything() {
      for (const product of this.value.page.products) {
        this.deselectAllMarketsForProduct(product);
      }
    },
    toggleShowMore(productId) {
      if (this.showMoreInfos[productId] === undefined) {
        this.showMoreInfos[productId] = false;
      }

      this.showMoreInfos[productId] = !this.showMoreInfos[productId];
    },
    selectAllMarketsForProduct(product) {
      if (this.productSelectedMarkets[product.productId] === undefined) {
        this.productSelectedMarkets[product.productId] = [];
      }

      for (const market of product.marketIds) {
        if (this.productSelectedMarkets[product.productId].indexOf(market) < 0) {
          this.productSelectedMarkets[product.productId].push(market);
        }
      }
    },
    deselectAllMarketsForProduct(product) {
      if (this.productSelectedMarkets[product.productId] === undefined) {
        this.productSelectedMarkets[product.productId] = [];
      }

      for (const market of product.marketIds) {
        const index = this.productSelectedMarkets[product.productId].indexOf(market);
        if (index >= 0) {
          this.productSelectedMarkets[product.productId].splice(index, 1);
        }
      }
    },
    getMarketName(marketId) {
      const market = this.value.marketList.filter(item => item.marketId === marketId);
      return market[0]?.name ?? null;
    },
    sortedMarkets(marketIds) {
      //remove markets without name and sort by name
      return marketIds.filter(marketId => this.getMarketName(marketId) !== null).sort((a, b) => this.getMarketName(a).localeCompare(this.getMarketName(b)));
    },
    toggleMarketSelection(productId, marketId) {


      if (this.productSelectedMarkets[productId] === undefined) {
        this.productSelectedMarkets[productId] = [];
      }

      const index = this.productSelectedMarkets[productId].indexOf(marketId);
      if (index >= 0) {
        this.productSelectedMarkets[productId].splice(index, 1);
      } else {
        this.productSelectedMarkets[productId].push(marketId);
      }


    }
  },
  mounted() {
    //load default values for selected markets
    for (const product of this.value.page.products) {

      if (this.productSelectedMarkets[product.productId] === undefined) {
        this.productSelectedMarkets[product.productId] = [];
      }
      this.productSelectedMarkets[product.productId].push(this.value.selectedMarketId);
    }


  }
}

</script>